{
  "satis_firma": {
    "Baslik": "Verkoopbedrijven",
    "Ad": "Bedrijfsnaam",
    "Durum": "Status",
    "Arama": "Zoeken",
    "Ara": "Zoeken",
    "Temizle": "Wissen",
    "Kapat": "Sluiten",
    "Yenile": "Vernieuwen",
    "Data Yenile": "Gegevens Vernieuwen",
    "Ekle": "Bedrijf Toevoegen",
    "Filtrele": "Filteren",
    "Duzenle": "Bewerken",
    "Sil": "Verwijderen",
    "Kaydet": "Opslaan",
    "Guncelle": "Bijwerken",
    "Vazgec": "Annuleren",
    "Iptal": "Annuleren",
    "Hepsi": "Alle",
    "Aktif": "Actief",
    "Pasif": "Passief",
    "ARA": "Zoeken"
  }
}
